const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:8001";

export default apiUrl;
